import { render } from "./PCMockUp.vue?vue&type=template&id=20a065c1"
import script from "./PCMockUp.vue?vue&type=script&lang=js"
export * from "./PCMockUp.vue?vue&type=script&lang=js"

import "./PCMockUp.vue?vue&type=style&index=0&id=20a065c1&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__